module.exports = __webpack_public_path__ + "img/checked.a6ec2179.svg";